'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _styles = require('@material-ui/core/styles');

var _Dialog = require('@material-ui/core/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _CircularProgress = require('@material-ui/core/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    card: {
      overflow: 'hide'
    },
    progress: {
      margin: theme.spacing.unit * 2
    }
  };
};

var Loading = function Loading(_ref) {
  var loadingSt = _ref.loadingSt,
      classes = _ref.classes;
  return _react2.default.createElement(
    _Dialog2.default,
    { open: loadingSt },
    _react2.default.createElement(
      'div',
      { className: classes.card },
      _react2.default.createElement(_CircularProgress2.default, { className: classes.progress })
    )
  );
};

var mapStateToProps = function mapStateToProps(state, props) {
  return (// eslint-disable-line
    {
      loadingSt: state.loading
    }
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({}, dispatch);
};

Loading.propTypes = {
  loadingSt: _propTypes2.default.bool.isRequired,
  classes: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _styles.withStyles)(styles)(Loading));